import React from 'react';
import styled from 'styled-components';
import { Tabs as AntdTabs } from 'antd';
import {
  TabsProps as AntdTabsProps,
  TabsType as AntdTabsType,
} from 'antd/lib/tabs';
import { StyledPrimaryTabs, StyledPrimaryTabBar } from './StyledComponents';

type TabsProps = Omit<AntdTabsProps, 'type'> & {
  type?: 'primary' | AntdTabsType;
};

export const Tabs: React.FC<TabsProps> = ({ type, ...props }) => {
  if (type === 'primary') {
    return (
      <StyledPrimaryTabs
        renderTabBar={(defaultProps, Default) => (
          <StyledPrimaryTabBar>
            <Default {...defaultProps} />
          </StyledPrimaryTabBar>
        )}
        {...props}
      />
    );
  }

  return <AntdTabs {...props} type={type} />;
};

// Any customization must be done in the parent component, because of antd's underlying logic
export const TabPane = styled(AntdTabs.TabPane)``;

export default styled(Tabs)``;
